import React, { useState, useEffect } from 'react';

import System from "../../../helper/system";
import { useBOMStore } from "../../../hooks/bom";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
const bomId = System.getParams().bomId;

const BomCreateProjectPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props
    const [projectName, SetProjectName] = useState('');
    const [projectNameError, SetProjectNameError] = useState('');
    const [{ }, { }, { create_project }] = useBOMStore();
    const { translation:t } = System;
    
    const onHide = (action = true) => {
        SetStatus(false)
    };

    const createProjectNow = async () => {
        let error = false
        if (projectName.trim().length === 0) {
            error = true;
            SetProjectNameError(t('pleaseEnterProjectName'))
        } else if (projectName.trim().length > 100) {
            error = true;
            SetProjectNameError(t('pleaseUseLessThan100Characters'))
        } else {
            error = false
            SetProjectNameError('');
        }

        if (!error) {
            let res = await create_project({ projectName, bomId });
            if (res?.ErrorCode) {
                SetProjectNameError(res.Message);
                return
            }
            onHide()
            SetProjectName('');
            if (data.props_afterBOMCreation !== undefined) {
                await data.props_afterBOMCreation();
            }
        }
    };

    return (
        <>
            <div className="avnet-modal">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×</button>
                    <div className="modal-header pb-2">
                        <h4 className="modal-title text-center" id="myModalLabel">{t('createNewProject')}</h4>
                    </div>
                    <div className="modal-body">
                        <div className="form-group mb-4">
                            <label htmlFor="Name">{t('projectName')}</label>
                            <input type="Name" placeholder={t('enterProjectName')} className={projectNameError ? "form-control form-control-sm error" : "form-control form-control-sm"} id="Name"
                                value={projectName}
                                onChange={(e) => {
                                    SetProjectName(e.target.value)
                                }}
                            />
                            <p className="error">{projectNameError}</p>
                        </div>
                    </div>
                    <div className="modal-footer text-center">
                        <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>{t('cancel')}
                        </button>
                        <button type="button" className="bs5 btn btn-primary w145"
                            onClick={async (e) => { __check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status ? e.preventDefault() : await createProjectNow(); }}>
                            {__check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status &&
                                <>
                                    <i className="fa fa-spinner fa-spin" />
                                </>
                            }
                            {!__check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status &&
                                <>
                                    {t('createAProject')}
                                </>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BomCreateProjectPopup;